/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  AddMedicationcategory,
  getb2bdetail,
  getOrganizationDataWithoutPagination,
  Updateb2b,
  getClaimTag,
  submitClaimTag,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import axios from "axios";
import Select from "react-select";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class editb2b extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      radioVariant: "1",
      company_name: "",
      company_nameError: null,
      discount: "",
      discountError: null,
      delivery_value: "",
      delivery_valueError: null,
      note: "",
      noteError: null,
      _notificationSystem: null,
      cardHidden: true,
      br_number: "",
      br_numberError: null,
      payment_method: "0",
      credit_period: "",
      type: "0",
      payment_methodError: null,
      credit_periodError: null,
      typeError: null,
      cpcode: "+94",
      address_line_1: "",
      address_line_1Error: null,
      errormessages: [],
      oldCompanyLogofile: "",
      company_logo: "",
      company_logo_data: "",
      contactdetiallist: [],
      deleted_contact: [],
      organizationOptions: [],
      parentOrganizationID: "",
      is_claimable: false,
      getB2bTags: [],
      tags: [],
      poolValue: null,
      industryTagError: null,
      challenge_type: "",
      invoiceReminderType: "",
      invoiceReminderWeekday: "sunday",
      invoiceReminderDay1: "15",
      invoiceReminderDay2: "30",
      invoiceReminderMonthlyDay: "month_end",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handlesubmit = this.handlesubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.code_error = React.createRef();
    this.handlecompany_logoFileChange =
      this.handlecompany_logoFileChange.bind(this);
  }

  handlecompany_logoFileChange(event) {
    this.setState({ company_logo: event.target.files[0] });
  }

  uploadcompany_logo() {
    document.getElementById("selectcompany_logo").click();
  }

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    var id = JSON.parse(localStorage.getItem("b2bid"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );
    getb2bdetail(id, obj).then((response) => {
      var data = response.data;
      var cpcode = "+94";

      var newContact_list = [];
      var contactlist = data.contacts;

      for (let i = 0; i < contactlist.length; i++) {
        var mobile = contactlist[i].mobile_no;
        var mobile_dial = "";
        if (mobile.substr(0, 4) == "+852") {
          mobile_dial = mobile.substr(0, 4);
          mobile = mobile.substr(4, mobile.length);
        } else {
          mobile_dial = mobile.substr(0, 3);
          mobile = mobile.substr(3, mobile.length);
        }
        var details = {
          name: contactlist[i].name,
          email: contactlist[i].email,
          mobile_no: mobile,
          user_type:
            contactlist[i].user_type == "Procurement"
              ? "1"
              : contactlist[i].user_type == "Finance"
                ? "2"
                : "",
          b2b_id: contactlist[i].id,
          ccode: mobile_dial,
          cperson_name_Error: "",
          cperson_email_Error: "",
          user_type_Error: "",
          cperson_mobile_Error: "",
        };

        newContact_list.push(details);
      }
      const tags = Array.isArray(data && data.tags)
        ? data.tags.map((t) => ({
            value: t.tag_id,
            label: (t.tag_name && t.tag_name.keyword) || "",
          }))
        : [];
      const invoiceReminderState = this.getInvoiceReminderState(
        data.invoice_reminder_cycle,
      );

      this.setState({
        id: data.id,
        company_name: data.company_name,
        discount: data.discount,
        delivery_value: data.delivery_value,
        note: data.note,
        br_number: data.br_number,
        payment_method: data.payment_method,
        parentOrganizationID: data.parent_org_id,
        type: data.type == "insuarance" ? 1 : 0,
        cpcode: cpcode,
        address_line_1: data.address_line1,
        oldCompanyLogofile: data.company_logo,
        contactdetiallist: newContact_list,
        credit_period: data.credit_period,
        is_claimable: data.is_claimable,
        tags: tags,
        poolValue: data.pool_value,
        challenge_type: data.challenge_type || "",
        ...invoiceReminderState,
      });
    });

    getOrganizationDataWithoutPagination(obj).then((cdata) => {
      const companyData = cdata.data;
      const organizationOptions = companyData.map((data) => {
        return {
          value: data.id,
          label: data.company_name,
        };
      });
      this.setState({ organizationOptions: organizationOptions });

      // this.setState({
      //   companyList: companyData,
      // });
    });
    getClaimTag(obj).then((res) => {
      const options = res.data.data.map((item) => ({
        label: item.keyword,
        value: item.id,
      }));
      this.setState({ getB2bTags: options });
    });
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>B2B</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });

    setTimeout(() => {
      this.props.history.push("/admin/viewb2b");
    }, 3000);
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  onParentOrganizationChange = (value) => {
    this.setState({
      parentOrganizationID: value,
    });
  };

  async handlesubmit(e) {
    this.setState({ errormessages: [] });
    let error = false;
    let company_nameErr = "";
    let creditPeriodError = "";
    let industryTagError = "  ";

    if (this.state.company_name.length == 0) {
      error = true;
      company_nameErr = (
        <small className="text-danger">Company Name is required.</small>
      );
    }
    if (!this.state.tags || this.state.tags.length === 0) {
      error = true;
      industryTagError = (
        <small className="text-danger">Industry is required.</small>
      );
    }
    if (this.state.credit_period === "" || this.state.credit_period === null) {
      error = true;
      creditPeriodError = (
        <small className="text-danger">Credit Period is required.</small>
      );
    }

    var contact_list_old = this.state.contactdetiallist;
    var errormessages = [];
    let Procurement = false;
    let Finance = false;

    if (contact_list_old.length == 0) {
      error = true;
      var errormessages = [];
      errormessages.push("Please add atleast one contact person detail.");
    } else {
      var emailReg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      for (let i = 0; i < contact_list_old.length; i++) {
        if (contact_list_old[i].name == "") {
          error = true;
          contact_list_old[i].cperson_name_Error = (
            <small className="text-danger">Please enter name</small>
          );
        }

        if (contact_list_old[i].email != "") {
          if (emailReg.test(contact_list_old[i].email) == false) {
            error = true;
            contact_list_old[i].cperson_email_Error = (
              <small className="text-danger">
                Please enter valid email address
              </small>
            );
          }
        }

        if (contact_list_old[i].mobile_no == "") {
          error = true;
          contact_list_old[i].cperson_mobile_Error = (
            <small className="text-danger">Please enter mobile number</small>
          );
        }

        if (contact_list_old[i].user_type == "") {
          error = true;
          contact_list_old[i].user_type_Error = (
            <small className="text-danger">Please select user type</small>
          );
        } else {
          if (contact_list_old[i].user_type === "1") {
            Procurement = true;
          }
          if (contact_list_old[i].user_type === "2") {
            Finance = true;
          }
        }
      }
      if (!Procurement) {
        error = true;
        errormessages.push("Please add 'Procurement' contact details.");
      }
      if (!Finance) {
        error = true;
        errormessages.push("Please add 'finance' contact details.");
      }
    }

    if (error) {
      this.setState({
        company_nameError: company_nameErr,
        contactdetiallist: contact_list_old,
        errormessages: errormessages,
        credit_periodError: creditPeriodError,
        industryTagError: industryTagError,
      });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var id = JSON.parse(localStorage.getItem("b2bid"));

      if (this.state.company_logo) {
        this.setState({ processing: true });

        const fdata = new FormData();
        fdata.append("company_logo", this.state.company_logo);
        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/comapany/logo";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            this.setState({
              company_logo_data: res.data.data.company_logo_url,
            });
          });
      } else {
        this.setState({ company_logo_data: this.state.oldCompanyLogofile });
      }

      var newContact_list = [];
      for (let i = 0; i < contact_list_old.length; i++) {
        var details_in = {
          id: contact_list_old[i].b2b_id,
          name: contact_list_old[i].name,
          email: contact_list_old[i].email,
          mobile_no: contact_list_old[i].ccode + contact_list_old[i].mobile_no,
          user_type:
            contact_list_old[i].user_type == 1 ? "Procurement" : "Finance",
        };
        newContact_list.push(details_in);
      }

      Updateb2b(
        this.state.company_name,
        this.state.discount,
        this.state.delivery_value,
        this.state.note,
        this.state.br_number,
        this.state.payment_method,
        this.state.type,
        this.state.address_line_1,
        id,
        this.state.company_logo_data,
        newContact_list,
        this.state.deleted_contact,
        this.state.parentOrganizationID,
        this.state.credit_period,
        this.state.is_claimable,
        this.state.poolValue,
        this.state.challenge_type,
        this.getInvoiceReminderCycle(),
        obj,
      )
        .then(async (res) => {
          if (res.data.success === false) {
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.code_error.current.focus();
              this.setState({ errormessages: ermessage });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            await this.handleSubmitTags(id);
            this.handleSuccess("bl");
          }
          // this.props.history.push('/admin/viewb2b');
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    }
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleAddClick = () => {
    this.setState({
      contactdetiallist: [
        ...this.state.contactdetiallist,
        {
          name: "",
          email: "",
          mobile_no: "",
          user_type: "",
          b2b_id: "0",
          ccode: "+94",
          cperson_name_Error: "",
          cperson_email_Error: "",
          user_type_Error: "",
          cperson_mobile_Error: "",
        },
      ],
    });
  };

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.contactdetiallist];
    if (name == "name") {
      list[index][name] = value;
      list[index]["cperson_name_Error"] = "";
      this.setState({ contactdetiallist: list });
    }

    if (name == "email") {
      list[index][name] = value;
      list[index]["cperson_email_Error"] = "";
      this.setState({ contactdetiallist: list });
    }

    if (name == "mobile_no") {
      const re = /^[0-9]*$/;
      if (re.test(value) == true && value.length <= 10) {
        list[index][name] = value;
      }

      list[index]["cperson_mobile_Error"] = "";
      this.setState({ contactdetiallist: list });
    }

    if (name == "user_type") {
      list[index][name] = value;
      list[index]["user_type_Error"] = "";
      this.setState({ contactdetiallist: list });
    }

    if (name == "ccode") {
      list[index][name] = value;
      this.setState({ contactdetiallist: list });
    }
  };

  handleCancelClick = (e, index) => {
    var data = this.state.contactdetiallist;
    var deletedId = this.state.deleted_contact;
    if (data[index].b2b_id != 0) {
      deletedId.push(data[index].b2b_id);
    }

    data.splice(index, 1);
    this.setState({
      contactdetiallist: data,
      deleted_contact: deletedId,
    });
  };
  handleCheckBoxClick = (e) => {
    this.setState({ is_claimable: e.target.checked });
  };
  handleSubmitTags = async (id) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const tagPayload = {
      order_id: id,
      tag_id: this.state.tags.map((t) => t.value),
      type: "b2b",
    };
    await submitClaimTag(obj, tagPayload);
  };

  getInvoiceReminderState = (cycle) => {
    if (!cycle || !cycle.type) {
      return {
        invoiceReminderType: "",
        invoiceReminderWeekday: "sunday",
        invoiceReminderDay1: "15",
        invoiceReminderDay2: "30",
        invoiceReminderMonthlyDay: "month_end",
      };
    }

    if (cycle.type === "weekly") {
      return {
        invoiceReminderType: cycle.type,
        invoiceReminderWeekday: cycle.days && cycle.days[0] ? cycle.days[0] : "sunday",
      };
    }

    if (cycle.type === "bi_monthly") {
      return {
        invoiceReminderType: cycle.type,
        invoiceReminderDay1: cycle.days && cycle.days[0] ? String(cycle.days[0]) : "15",
        invoiceReminderDay2: cycle.days && cycle.days[1] ? String(cycle.days[1]) : "30",
      };
    }

    if (cycle.type === "monthly") {
      return {
        invoiceReminderType: cycle.type,
        invoiceReminderMonthlyDay:
          cycle.days && cycle.days[0] ? String(cycle.days[0]) : "month_end",
      };
    }

    return {
      invoiceReminderType: "",
    };
  };

  getInvoiceReminderCycle = () => {
    if (!this.state.is_claimable) {
      return null;
    }

    const type = this.state.invoiceReminderType;
    if (!type) {
      return null;
    }

    if (type === "weekly") {
      return {
        enabled: true,
        type,
        days: [this.state.invoiceReminderWeekday],
      };
    }

    if (type === "bi_monthly") {
      return {
        enabled: true,
        type,
        days: [
          parseInt(this.state.invoiceReminderDay1, 10),
          parseInt(this.state.invoiceReminderDay2, 10),
        ].filter((day) => !Number.isNaN(day)),
      };
    }

    if (type === "monthly") {
      const day = this.state.invoiceReminderMonthlyDay;
      return {
        enabled: true,
        type,
        days: [day === "month_end" ? "month_end" : parseInt(day, 10)],
      };
    }

    return null;
  };

  renderInvoiceReminderFields = () => {
    if (!this.state.invoiceReminderType) {
      return null;
    }

    if (this.state.invoiceReminderType === "weekly") {
      return (
        <FormGroup>
          <ControlLabel>Invoice Day</ControlLabel>
          <select
            className="form-control"
            value={this.state.invoiceReminderWeekday}
            onChange={(event) =>
              this.setState({ invoiceReminderWeekday: event.target.value })
            }
          >
            <option value="monday">Monday</option>
            <option value="tuesday">Tuesday</option>
            <option value="wednesday">Wednesday</option>
            <option value="thursday">Thursday</option>
            <option value="friday">Friday</option>
            <option value="saturday">Saturday</option>
            <option value="sunday">Sunday</option>
          </select>
        </FormGroup>
      );
    }

    if (this.state.invoiceReminderType === "bi_monthly") {
      return (
        <Row>
          <Col sm={6} xs={12}>
            <FormGroup>
              <ControlLabel>Invoice Day 1</ControlLabel>
              <FormControl
                value={this.state.invoiceReminderDay1}
                onWheel={(e) => e.target.blur()}
                onChange={(event) =>
                  this.setState({ invoiceReminderDay1: event.target.value })
                }
                min="1"
                max="31"
                type="number"
              />
            </FormGroup>
          </Col>
          <Col sm={6} xs={12}>
            <FormGroup>
              <ControlLabel>Invoice Day 2</ControlLabel>
              <FormControl
                value={this.state.invoiceReminderDay2}
                onWheel={(e) => e.target.blur()}
                onChange={(event) =>
                  this.setState({ invoiceReminderDay2: event.target.value })
                }
                min="1"
                max="31"
                type="number"
              />
            </FormGroup>
          </Col>
        </Row>
      );
    }

    if (this.state.invoiceReminderType === "monthly") {
      return (
        <FormGroup>
          <ControlLabel>Invoice Day</ControlLabel>
          <select
            className="form-control"
            value={this.state.invoiceReminderMonthlyDay}
            onChange={(event) =>
              this.setState({ invoiceReminderMonthlyDay: event.target.value })
            }
          >
            <option value="month_end">Month End</option>
            {Array.from({ length: 31 }, (_, index) => (
              <option key={index + 1} value={index + 1}>
                {index + 1}
              </option>
            ))}
          </select>
        </FormGroup>
      );
    }

    return null;
  };

  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <FormGroup>
                      <ControlLabel> Company name</ControlLabel>
                      <FormControl
                        name="company_name"
                        value={this.state.company_name || ""}
                        onChange={(event) => {
                          this.setState({ company_name: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                company_nameError: (
                                  <small className="text-danger">
                                    Company Name is required.
                                  </small>
                                ),
                              })
                            : this.setState({ company_nameError: null });
                        }}
                        placeholder="Enter Companyname"
                        type="text"
                      />
                      {this.state.company_nameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Type</ControlLabel>
                      <select
                        name="challenge_type"
                        className="form-control"
                        rows="3"
                        value={this.state.challenge_type || ""}
                        onChange={(event) => {
                          this.setState({ challenge_type: event.target.value });
                        }}
                      >
                        <option value="">Select Type</option>
                        <option value="step_challenge">
                          Step Challenge Program
                        </option>
                        <option value="benefit_package">
                          Solely Benefit Package
                        </option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Discount</ControlLabel>
                      <FormControl
                        name="discount"
                        value={this.state.discount || ""}
                        onWheel={(e) => e.target.blur()}
                        onChange={(event) => {
                          this.setState({ discount: event.target.value });
                        }}
                        placeholder="Enter Discount"
                        type="number"
                      />
                      {this.state.discountError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Delivery Value</ControlLabel>
                      <FormControl
                        name="delivery_value"
                        value={this.state.delivery_value || ""}
                        onWheel={(e) => e.target.blur()}
                        onChange={(event) => {
                          this.setState({ delivery_value: event.target.value });
                        }}
                        placeholder="Enter Delivery Value"
                        type="number"
                      />
                      {this.state.delivery_valueError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>BR Number</ControlLabel>
                      <FormControl
                        type="number"
                        name="br_number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        value={this.state.br_number || ""}
                        onChange={(event) => {
                          this.setState({ br_number: event.target.value });
                          // event.target.value === ""
                          //   ? this.setState({
                          //     br_numberError: (
                          //         <small className="text-danger">
                          //           BR Number is required.
                          //         </small>
                          //       )
                          //     })
                          //   : this.setState({ br_numberError: null });
                        }}
                        placeholder="Enter br_number"
                      />
                      {this.state.br_numberError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Address Line 1 </ControlLabel>
                      <FormControl
                        name="address_line_1"
                        value={this.state.address_line_1}
                        onChange={(event) => {
                          this.setState({ address_line_1: event.target.value });
                          // event.target.value === ""
                          //   ? this.setState({
                          //     address_line_1Error: (
                          //         <small className="text-danger">
                          //           Address Line 1 is required.
                          //         </small>
                          //       )
                          //     })
                          //   : this.setState({ address_line_1Error: null });
                        }}
                        placeholder="Enter Address Line 1"
                        type="text"
                      />
                      {this.state.address_line_1Error}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Payment Method</ControlLabel>
                      <select
                        name="payment_method"
                        className="form-control"
                        rows="3"
                        value={this.state.payment_method || ""}
                        onChange={(event) => {
                          this.setState({ payment_method: event.target.value });
                        }}
                      >
                        <option value="0">Select Payment Method</option>
                        <option value="1">Cash</option>
                        <option value="2">Card</option>
                        <option value="3">Cheque</option>
                      </select>
                      {this.state.payment_methodError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Parent Organization</ControlLabel>
                      <Select
                        style={{ textTransform: "capitalize" }}
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="parentOrganization"
                        // value={this.state.subscriberItems.find(obj => obj.value == sub_id)}
                        onChange={(value) =>
                          this.onParentOrganizationChange(value.value)
                        }
                        value={this.state.organizationOptions.find(
                          (item) =>
                            item.value === this.state.parentOrganizationID,
                        )}
                        options={this.state.organizationOptions}
                        placeholder="Parent Organization"
                        noOptionsMessage={() => "Type Name of Organization"}
                      />
                    </FormGroup>
                    {/* <FormGroup>
                      <ControlLabel>Company Type</ControlLabel>
                      <select
                        name="type"
                        className="form-control"
                        rows="3"
                        value={this.state.type || ""}
                        onChange={(event) => {
                          this.setState({ type: event.target.value });
                        }}
                      >
                        <option value="0">Genaric</option>
                        <option value="1">Insuarance</option>
                      </select>
                      {this.state.typeError}
                    </FormGroup> */}
                    <FormGroup>
                      <ControlLabel>Industry</ControlLabel>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        isMulti
                        closeMenuOnSelect={false}
                        value={this.state.tags}
                        onChange={(newValue) =>
                          this.setState({
                            tags: newValue,
                            industryTagError: null,
                          })
                        }
                        options={this.state.getB2bTags}
                        placeholder="select Industry"
                        noOptionsMessage={() => "No tags found"}
                        isClearable
                      />
                      {this.state.industryTagError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Credit Period</ControlLabel>
                      <select
                        name="credit_period"
                        className="form-control"
                        value={this.state.credit_period}
                        onChange={(event) => {
                          const value = event.target.value;
                          this.setState({
                            credit_period: value,
                            credit_periodError: null,
                          });
                        }}
                      >
                        <option value="0">Select Credit Period</option>
                        <option value="7 Days">7 Days</option>
                        <option value="14 Days">14 Days</option>
                        <option value="21 Days">21 Days</option>
                        <option value="30 Days">30 Days</option>
                      </select>
                    </FormGroup>
                    {this.state.credit_periodError}
                    {this.state.is_claimable && (
                      <React.Fragment>
                        <FormGroup>
                          <ControlLabel>Invoice Reminder Cycle</ControlLabel>
                          <select
                            className="form-control"
                            value={this.state.invoiceReminderType}
                            onChange={(event) =>
                              this.setState({
                                invoiceReminderType: event.target.value,
                              })
                            }
                          >
                            <option value="">No Reminder Cycle</option>
                            <option value="weekly">Weekly</option>
                            <option value="bi_monthly">Twice a Month</option>
                            <option value="monthly">Monthly</option>
                          </select>
                        </FormGroup>
                        {this.renderInvoiceReminderFields()}
                      </React.Fragment>
                    )}
                    {/* <FormGroup>
                      <ControlLabel>Pool Value </ControlLabel>
                      <FormControl
                        name="poolValue"
                        value={this.state.poolValue}
                        onChange={(event) => {
                          this.setState({ poolValue: event.target.value });
                        }}
                        placeholder="Enter Pool Value"
                        type="number"
                      />
                    </FormGroup> */}
                    <FormGroup>
                      <ControlLabel>Pool Value </ControlLabel>
                      <FormControl
                        name="poolValue"
                        value={this.state.poolValue}
                        onWheel={(e) => e.target.blur()}
                        onChange={(event) => {
                          this.setState({ poolValue: event.target.value });
                        }}
                        placeholder="Enter Pool Value"
                        type="number"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Note</ControlLabel>
                      <textarea
                        name="note"
                        className="form-control"
                        rows="3"
                        value={this.state.note || ""}
                        onChange={(event) => {
                          this.setState({ note: event.target.value });
                        }}
                        placeholder="Enter Note"
                      ></textarea>
                      {this.state.noteError}
                    </FormGroup>

                    <div>
                      {this.state.contactdetiallist.map((x, i) => (
                        <>
                          <h2 className="contacttitle">Contact {i + 1}</h2>
                          <div className="contactdetiallist_heading_b2b">
                            <Row>
                              <Col sm={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Name</ControlLabel>
                                  <FormControl
                                    name="name"
                                    value={x.name}
                                    onChange={(e) =>
                                      this.handleInputChange(e, i)
                                    }
                                    placeholder="Enter Name"
                                    type="text"
                                  />
                                  {x.cperson_name_Error}
                                </FormGroup>
                              </Col>

                              <Col sm={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Email</ControlLabel>
                                  <FormControl
                                    name="email"
                                    value={x.email}
                                    onChange={(e) =>
                                      this.handleInputChange(e, i)
                                    }
                                    placeholder="Enter Email"
                                    type="text"
                                  />
                                  {x.cperson_email_Error}
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Mobile number</ControlLabel>
                                  <div className="phone_input_form">
                                    <select
                                      onChange={(e) =>
                                        this.handleInputChange(e, i)
                                      }
                                      name="ccode"
                                      value={x.ccode}
                                      className="form-control phone_dial_code"
                                    >
                                      <option value="+94">+94</option>
                                      <option value="+91">+91</option>
                                      <option value="+852">+852</option>
                                    </select>
                                    <FormControl
                                      name="mobile_no"
                                      value={x.mobile_no}
                                      onChange={(e) =>
                                        this.handleInputChange(e, i)
                                      }
                                      placeholder="Enter Mobile Number"
                                      type="text"
                                    />
                                  </div>

                                  {x.cperson_mobile_Error}
                                </FormGroup>
                              </Col>

                              <Col sm={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>User type</ControlLabel>
                                  <select
                                    onChange={(e) =>
                                      this.handleInputChange(e, i)
                                    }
                                    name="user_type"
                                    value={x.user_type}
                                    className="form-control"
                                    style={{ marginTop: "0.9rem" }}
                                  >
                                    <option value="">Select User Type</option>
                                    <option value="1">Procurement</option>
                                    <option value="2">Finance</option>
                                  </select>
                                </FormGroup>
                                {x.user_type_Error}
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={6} xs={12}>
                                <Button
                                  class="btn btn-color"
                                  fill
                                  onClick={(e) => this.handleCancelClick(e, i)}
                                >
                                  Cancel
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        </>
                      ))}
                      <FormGroup>
                        <Checkbox
                          number="1"
                          checked={this.state.is_claimable}
                          onClick={(e) => this.handleCheckBoxClick(e)}
                          label="Claimable Organization"
                        ></Checkbox>
                      </FormGroup>

                      <Button
                        class="btn-color"
                        fill
                        onClick={this.handleAddClick}
                        className="add_contact_person_btn"
                      >
                        Add Contact Person<i className="fa fa-plus"></i>
                      </Button>
                    </div>

                    <FormGroup>
                      <ControlLabel>Company Logo</ControlLabel>
                      <br></br>
                      {this.state.oldCompanyLogofile != null ? (
                        <>
                          <a
                            target="_blank"
                            href={this.state.oldCompanyLogofile}
                          >
                            <img
                              style={{
                                height: "35px",
                                width: "35px",
                                border: "1px solid black",
                                borderRadius: "50%",
                                marginBottom: "3px",
                              }}
                              src={this.state.oldCompanyLogofile}
                            ></img>
                          </a>
                          <br></br>
                        </>
                      ) : (
                        ""
                      )}
                      <input
                        style={{ display: "none" }}
                        id="selectcompany_logo"
                        type="file"
                        className="form-control"
                        name="company_logo"
                        onChange={this.handlecompany_logoFileChange}
                      />
                      <Button
                        onClick={this.uploadcompany_logo}
                        style={{ color: "#2B3A41" }}
                      >
                        {" "}
                        <i
                          className={
                            this.state.company_logo == ""
                              ? "fa fa-plus"
                              : "fa fa-pencil fa-fw"
                          }
                        ></i>{" "}
                        {this.state.company_logo == ""
                          ? "Choose Company Logo"
                          : "Change Company Logo"}
                      </Button>
                    </FormGroup>

                    <Button
                      onClick={this.handlesubmit.bind(this)}
                      class="btn-color"
                      fill
                    >
                      Update
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editb2b;
